import React from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import type { SupplierOrderFreightRow } from '../supplierOrderFreight';
import FreightOrderCard from './FreightOrderCard';

const { Text } = Typography;

interface SupplierOrderFreightCardsProps {
  /** Truck currency, PLN rate and total (usability round 2026-10-05). */
  truck?: { currency: string; rate: number | null; totalPLN: number | null } | null;
  rows: SupplierOrderFreightRow[];
  onOpenSupplierOrder: (supplierOrderId: string) => void;
}

/**
 * INBOUND truck: one card per linked ZD with its saved freight share
 * (supplierOrderFreight.ts), rendered with the shared `FreightOrderCard`.
 * A ZD without a saved share says so instead of showing the table.
 * Render only with `canViewTransportCosts`.
 */
const SupplierOrderFreightCards: React.FC<SupplierOrderFreightCardsProps> = ({ truck = null, rows, onOpenSupplierOrder }) => {
  const { t } = useTranslation(['transport']);
  return (
    <div className="transport-detail-card-list" data-testid="transport-supplier-freight-list">
      {rows.map((row) => (
        <FreightOrderCard
          key={row.id}
          testIdPrefix="transport-supplier-freight"
          label={row.label}
          partyName={row.supplierName}
          onOpen={() => onOpenSupplierOrder(row.id)}
          truck={truck}
          share={row.share}
          showShareAmount={rows.length > 1}
          lines={row.lines}
          totals={row.totals}
          showTable={row.share !== null}
          emptyContent={<Text type="secondary">{t('transport:supplierOrders.freight.noShare')}</Text>}
        />
      ))}
    </div>
  );
};

export default SupplierOrderFreightCards;
